module.exports = __webpack_public_path__ + "img/avatar1.8cb84c2d.png";